module.exports = __webpack_public_path__ + "img/icon-bigData.ca293951.png";